import { defineMessages } from 'react-intl'

export default defineMessages({
  hiddenState: {
    id: 'containers.SupplierJobOverviewPage.hiddenState',
    defaultMessage: 'Hidden',
  },
  doneState: {
    id: 'containers.SupplierJobOverviewPage.doneState',
    defaultMessage: 'Done',
  },
  inProgressState: {
    id: 'containers.SupplierJobOverviewPage.inProgressState',
    defaultMessage: 'In Progress',
  },
  hideJobsButton: {
    id: 'containers.SupplierJobOverviewPage.hideJobsButton',
    defaultMessage: 'Hide jobs',
  },
  unhideJobsButton: {
    id: 'containers.SupplierJobOverviewPage.unhideJobsButton',
    defaultMessage: 'Unhide jobs',
  },
  showHiddenJobsButton: {
    id: 'containers.SupplierJobOverviewPage.showHiddenJobsButton',
    defaultMessage: 'Show hidden jobs',
  },
  hideHiddenJobsButton: {
    id: 'containers.SupplierJobOverviewPage.hideHiddenJobsButton',
    defaultMessage: 'Hide hidden jobs',
  },
  showFullListButton: {
    id: 'containers.SupplierJobOverviewPage.showFullListButton',
    defaultMessage: 'Show full list',
  },
  idLabel: {
    id: 'containers.SupplierJobOverviewPage.idLabel',
    defaultMessage: 'ID',
  },
  deadlineLabel: {
    id: 'containers.SupplierJobOverviewPage.deadlineLabel',
    defaultMessage: 'Deadline',
  },
  stateLabel: {
    id: 'containers.SupplierJobOverviewPage.stateLabel',
    defaultMessage: 'State',
  },
  statusLabel: {
    id: 'containers.SupplierJobOverviewPage.statusLabel',
    defaultMessage: 'Status',
  },
  recordingsLabel: {
    id: 'containers.SupplierJobOverviewPage.recordingsLabel',
    defaultMessage: 'Recordings',
  },
  titleLabel: {
    id: 'containers.SupplierJobOverviewPage.titleLabel',
    defaultMessage: 'Title',
  },
  dueToday: {
    id: 'containers.SupplierJobOverviewPage.dueToday',
    defaultMessage: 'due today',
  },
  dueTomorrow: {
    id: 'containers.SupplierJobOverviewPage.dueTomorrow',
    defaultMessage: 'due tomorrow',
  },
  pastFutureJobs: {
    id: 'containers.SupplierJobOverviewPage.pastFutureJobs',
    defaultMessage: 'other past/future jobs',
  }
})
